<div
  style="margin-left: -1.5rem !important; margin-right: -1.5rem !important"
  class="px-4 py-1 bg-white"
>
  <ion-list lines="none">
    <ion-item>
      <ion-label>{{ title }} </ion-label>

      @if (warning) {
        <div slot="end" class="color-medium">
          <i class="fa-solid {{ icon }} color-orange"></i>
        </div>
      } @else {
        <div slot="end" class="color-medium">
          {{ text }}
        </div>
      }
    </ion-item>
  </ion-list>
</div>
